var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Mains'),_c('Main'),_c('Aboutus'),_c('Howtouse'),_c('paymentMethod'),_c('Location'),_c('Hardware'),_c('Advantages'),_c('Partner'),_c('Freedom'),_c('Cooperate')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }